import { render, staticRenderFns } from "./Mytopfive.vue?vue&type=template&id=1148af69&"
import script from "./Mytopfive.vue?vue&type=script&lang=js&"
export * from "./Mytopfive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports